import { useRouter } from 'next/router';
import { useCallback } from 'react';
import { clearPaypalFromSession } from '@g4/next-furniture/utils/paypalUtils';

const useTransactionId = () => {
  const router = useRouter();

  return useCallback(
    ({ transactionId }) => {
      // When we execute the stadium query for that transaction id
      // The shopped stadium games details will going to store in redis server for that transaction id
      // Return if there is already transaction id in the query
      if (router.query.transactionId) {
        return;
      }
      // clear the paypal token
      clearPaypalFromSession();
      router.replace(
        {
          pathname: '/booking/flights',
          query: {
            ...router.query,
            transactionId,
          },
        },
        {
          pathname: `/booking/${transactionId}/flights`,
          query: router.query,
        }
      );
    },
    [router]
  );
};

export default useTransactionId;
